import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import ProductCode from "./ProductCode";
import ProductName from "./ProductName";
import Variations from "./Variations";
import BarcodelistView from "./BarcodelistView";
import OldBarcodelistView from "./OldBarcodelistView";
import BatchBarcodelistView from "./BatchBarcodelistView";
import Datewisebarcode from "./Datewisebarcode";
import BatchwiseBarcode from "./BatchwiseBarcode";
import "../../../barcode.css";
import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Select,
  Divider,
  AutoComplete,
  Form,
  Tabs
} from "antd";

const { Option } = Select;

const Barcode = () => {
  const [reload, setreload] = useState(true);
  const [loading, setloading] = useState(false);
  const count = useRef(0);
  const [products, setproducts] = useState([]);
  const [variations, setvariations] = useState([]);
  const SelectedProduct = useRef([]);
  const SelectedVariation = useRef([]);
  const barcodelist = useRef([]);
  const oldBarcodelist = useRef([]);
  const singleBarcodelist = useRef([]);
  const [form] = Form.useForm();

  const onChange = (key) => {
    barcodelist.current = [];
    oldBarcodelist.current = [];
    singleBarcodelist.current = [];
    setreload(!reload);
  };

  const addProduct = () => {
    return (
      <>
        <Tabs onChange={onChange}>
          <Tabs.TabPane tab="Filter by batch number (Batch)" key="1">
            <BatchwiseBarcode
              setloading={setloading}
              barcodelist={barcodelist}
              setreload={setreload}
              reload={reload}
            />
            <Divider />
            <BatchBarcodelistView
              barcodelist={barcodelist}
              reload={reload}
              count={count}
            />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Filter by batch number (Single)" key="2">
            <BatchwiseBarcode
              setloading={setloading}
              barcodelist={singleBarcodelist}
              setreload={setreload}
              reload={reload}
            />
            <Divider />
            <BarcodelistView
              barcodelist={singleBarcodelist}
              reload={reload}
              count={count}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Filter by batch number (All)" key="3">
            <BatchwiseBarcode
              setloading={setloading}
              barcodelist={oldBarcodelist}
              setreload={setreload}
              reload={reload}
            />
            <Divider />
            <OldBarcodelistView
              barcodelist={oldBarcodelist}
              reload={reload}
              count={count}
            />
          </Tabs.TabPane>
        </Tabs>
      </>
    );
  };

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Products</Breadcrumb.Item>
        <Breadcrumb.Item>barcode</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">{addProduct()}</div>
    </>
  );
};

export default connect(null, {})(Barcode);





// import React, { useState, useRef } from "react";
// import { connect } from "react-redux";
// import ProductCode from "./ProductCode";
// import ProductName from "./ProductName";
// import Variations from "./Variations";
// import BarcodelistView from "./BarcodelistView";
// import OldBarcodelistView from "./OldBarcodelistView";
// import Datewisebarcode from "./Datewisebarcode";
// import BatchwiseBarcode from "./BatchwiseBarcode";
// import "../../../barcode.css";

// import {
//   Layout,
//   Breadcrumb,
//   Row,
//   Col,
//   Select,
//   Divider,
//   AutoComplete,
//   Form,
//   Tabs
// } from "antd";
// const { Option } = Select;

// const Barcode = () => {
//   const [reload, setreload] = useState(true);
//   const [loading, setloading] = useState(false);
//   const count = useRef(0);
//   const [products, setproducts] = useState([]);
//   const [variations, setvariations] = useState([]);
//   const SelectedProduct = useRef([]);
//   const SelectedVariation = useRef([]);
//   const barcodelist = useRef([]);
//   const [form] = Form.useForm();

//   const onChange = (key) => {
//     barcodelist.current = []
//     setreload(!reload);
//   };

//   const addProduct = () => {
//     return (
//       <>
//         <Tabs onChange={onChange}>


//           <Tabs.TabPane tab="Filter by batch number" key="1">
//             <BatchwiseBarcode
//               setloading={setloading}
//               barcodelist={barcodelist}
//               setreload={setreload}
//               reload={reload}
//             />
//           </Tabs.TabPane>
//           {/* <Tabs.TabPane tab="Filter by individual product" key="2">
//             <Row>
//               <Col span={6}>
//                 <ProductName
//                   setproducts={setproducts}
//                   setvariations={setvariations}
//                   setloading={setloading}
//                   loading={loading}
//                 />
//               </Col>
//               <Variations
//                 variations={variations}
//                 barcodelist={barcodelist}
//                 setreload={setreload}
//                 reload={reload}
//                 loading={loading}
//               />
//             </Row>
//           </Tabs.TabPane> */}

//           {/* <Tabs.TabPane tab="Filter by product create date" key="3">
//             <Datewisebarcode
//               setloading={setloading}
//               barcodelist={barcodelist}
//               setreload={setreload}
//               reload={reload}
//             />
//           </Tabs.TabPane> */}

//         </Tabs>
//         <Divider />

//         <BarcodelistView
//           barcodelist={barcodelist}
//           reload={reload}
//           count={count}
//         />

//         <OldBarcodelistView
//           barcodelist={barcodelist}
//           reload={reload}
//           count={count}
//         />


//       </>
//     );
//   };

//   return (
//     <>
//       <Breadcrumb style={{ margin: "16px 0" }}>
//         <Breadcrumb.Item>Products</Breadcrumb.Item>
//         <Breadcrumb.Item>barcode</Breadcrumb.Item>
//       </Breadcrumb>
//       <div className="site-layout-background main-frame">{addProduct()}</div>
//     </>
//   );
// };

// export default connect(null, {})(Barcode);